const translations = {
  "en": {
    "Ask Edgen AI": "Ask Ed AI"
  },
  "zh-tw": {
    "Ask Edgen AI": "詢問 Ed AI"
  }
};

export default translations;
